import { render, staticRenderFns } from "./destinatario-component.vue?vue&type=template&id=d4888082&"
import script from "./destinatario-component.vue?vue&type=script&lang=js&"
export * from "./destinatario-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports